import React, { useState } from 'react';
import Avatar from 'react-avatar';
import { useDispatch, useSelector } from 'react-redux';
import NotesModal from 'shared/modals/NotesModal';
import { ActivityPopup } from 'shared/forms/NewActivity';
import SendEmailModal from 'shared/modals/SendEmailModal';
import { ClippedContent, Contact } from 'dyl-components';
import { PhoneUtil } from 'utils';
import { TextMessageModal } from 'shared/modals';
import TextIcon from 'shared/TextIcon';

const Account = ({ name, id, linkToAccount, isActionsVisible, account, isModalOutside = false }) => {
    const [openForm, setOpenForm] = useState(false);
    const onCloseForm = () => {
        setOpenForm('');
    }

    const dispatch = useDispatch();

    const { emailIntegrations, officeViewCreds } = useSelector((state) => {
        return {
            officeViewCreds: state.officeView.creds,
            emailIntegrations: state.oauth_integrations.integrations,
        };
    });
    const isPhoneSystemSupported =
        PhoneUtil.isPhoneSystemSupported(officeViewCreds);
    const phone = account?.phone?.phone || account?.phone;
    const canEmail = Boolean(account.email?.id) || account?.email;
    const hasEmailIntegrations = emailIntegrations.length > 0;
    const getModal = () => {
        switch (openForm) {
            case "email":
                return <SendEmailModal
                    open
                    onClose={onCloseForm}
                    account_id={account?.id}
                    isAccountModal={true}
                    account={account}
                />;
            case "note":
                return <NotesModal
                    open
                    onClose={onCloseForm}
                    account={account}
                />;
            case "text":
                return <TextMessageModal
                    open
                    onClose={onCloseForm}
                    contact_id={account.id}
                    contact_name={`${account.name}`}
                    isAccount
                />;    
            default:
                <React.Fragment />
        }
    }

    const onClickToDial = () => {
        PhoneUtil.C2D({ payload: { account_id: account.id, destination: phone }, dispatch });
    }

    return (
        <>
            <Contact
                leftSideContent={
                    <>
                        {name && <Avatar name={name} maxInitials={2} round size='3em' />}
                        <span className='Contact__Link'>
                            <ClippedContent>{linkToAccount}</ClippedContent>
                            <span className="Contact__Subtitle">{id && `ID: ${id}`}</span>
                        </span>
                    </>
                }
                phone={phone}
                email={canEmail ? account.email : null}
                account_id={account?.id}
                isPhoneSystemSupported={isPhoneSystemSupported}
                hasEmailIntegrations={hasEmailIntegrations}
                onCallClick={onClickToDial}
                onTextClick={() => setOpenForm('text')}
                onEmailClick={() => setOpenForm('email')}
                onNoteClick={() => setOpenForm('note')}
                ActivityPopup={ActivityPopup}
                TextIcon={TextIcon}
                callActivityProps={{
                    hideActivitySelection: true,
                    account: {
                        id: account?.id,
                    }
                }}
                emailActivityProps={{
                    readTimeline: () => { },
                    emailOnly: true,
                    account: account
                }}
                isActionsVisible={isActionsVisible}
            />
            {!isModalOutside && getModal()}
        </>
    );
}

export default Account;
